export default __webpack_public_path__ + "622c5bb472a639df175f863db8e1a5a1.svg";